// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"0":"554e362e509277fed5ff","12":"d49d4f41f47a54841a01","565":"6fee7263425738d5adc8","657":"381ae00d63945a8d2fbd","847":"014e222a734bae7b86d7","943":"bea2e3d14e0a24baea29"}[chunkId] + ".js";
};